import { PageTitle } from '@/shared/components/PageTitle/PageTitle'
import { useIsMobile } from '@/shared/utils'

export const RefPageHeader = () => {
  const isMobile = useIsMobile()
  const pageTitle = isMobile ? 'Реф.кабинет' : 'Реферальная система'
  return (
    <div className="flex items-center justify-between">
      <PageTitle title={pageTitle} />
    </div>
  )
}
